import React from 'react';
import { AtdwMap } from './view/atdwMap';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === '--AtdwMap', 
  itemElt: (item, cmsOption) => <AtdwMap item={item} cmsOption={cmsOption} />
}